/* Банк крові (/blood-bank, batch B5). Kept apart from uk.ts/en.ts to keep merges small. */
export const bloodbankUk = {
  'nav.bloodBank': 'Банк крові',
  'process.area.blood_bank': 'Банк крові',
  'perm.bloodbank.read': 'Банк крові: перегляд і дзвінки донорам',
  'perm.bloodbank.manage': 'Банк крові: донори, донації, одиниці',
  'blood.subtitle': 'Донори, одиниці крові з термінами придатності, запити на донорів і щомісячне списання',
  'blood.tabStock': 'Запаси',
  'blood.tabDonors': 'Донори',
  'blood.tabRequests': 'Запити',
  'blood.tabPack': 'Списання за місяць',
  'blood.statInStock': 'Одиниць у наявності',
  'blood.statExpiring': 'Термін спливає (≤ {n} дн)',
  'blood.statExpired': 'Прострочено — списати',
  'blood.statDonors': 'Донори',
  'blood.statDonorsSub': 'допущені зараз / активні',
  'blood.statRequests': 'Відкриті запити',
  'blood.normsToConfirm': 'Нормативів банку крові, що чекають підтвердження власника: {n}.',
  'blood.openNorms': 'Відкрити нормативи',
  'blood.stockByGroup': 'Наявність за групами',
  'blood.noStock': 'Одиниць крові в наявності немає',
  'blood.noStockHint': 'Зареєструйте донацію в картці донора або додайте одиницю з паперового реєстру.',
  'blood.searchUnits': 'Код етикетки, донор або реципієнт',
  'blood.filterInStock': 'У наявності й прострочені',
  'blood.filterSoon': 'Термін спливає',
  'blood.filterHistory': 'Використані й списані',
  'blood.allSpecies': 'Усі види',
  'blood.allProducts': 'Усі продукти',
  'blood.addUnit': 'Додати одиницю',
  'blood.addUnitHint': 'Для одиниць з паперового реєстру. Нові донації реєструйте в картці донора.',
  'blood.noUnits': 'Одиниць за цим фільтром немає',
  'blood.noUnitsHint': 'Змініть фільтр або зареєструйте донацію в картці донора.',
  'blood.col.code': 'Код',
  'blood.col.product': 'Продукт',
  'blood.col.group': 'Вид і група',
  'blood.col.groups': 'Групи (доступно + резерв)',
  'blood.col.volume': 'Об’єм',
  'blood.col.collected': 'Заготовлено',
  'blood.col.expires': 'Придатна до',
  'blood.col.nextExpiry': 'Найближчий термін',
  'blood.col.location': 'Місце зберігання',
  'blood.col.status': 'Стан',
  'blood.col.species': 'Вид',
  'blood.col.donor': 'Донор',
  'blood.col.ageWeight': 'Вік · вага',
  'blood.col.lastDonation': 'Остання донація',
  'blood.col.nextDonation': 'Наступна можлива',
  'blood.col.request': 'Запит',
  'blood.col.calls': 'Дзвінки',
  'blood.col.inStock': 'Сумісних у наявності',
  'blood.col.created': 'Створено',
  'blood.col.date': 'Дата',
  'blood.col.donationKind': 'Донація',
  'blood.col.visit': 'Візит Enote',
  'blood.col.forPatient': 'Під пацієнта',
  'blood.col.visitTotal': 'Сума візиту',
  'blood.col.writeOff': 'Списати',
  'blood.col.bonus': 'Бонус',
  'blood.col.foreign': 'Сторонні позиції',
  'blood.col.warnings': 'Перевірити',
  'blood.col.writtenOffAt': 'Списано',
  'blood.col.by': 'Хто',
  'blood.product.rbc': 'Еритроцитарна маса',
  'blood.product.plasma': 'Плазма',
  'blood.product.whole': 'Цільна кров',
  'blood.species.dog': 'Собака',
  'blood.species.cat': 'Кіт',
  'blood.unitStatus.available': 'Доступна',
  'blood.unitStatus.reserved': 'Зарезервована',
  'blood.unitStatus.used': 'Використана',
  'blood.unitStatus.expired': 'Прострочена',
  'blood.unitStatus.written_off': 'Списана',
  'blood.donorStatus.candidate': 'Кандидат',
  'blood.donorStatus.active': 'Активний',
  'blood.donorStatus.paused': 'Призупинено',
  'blood.donorStatus.retired': 'Вибув',
  'blood.outcome.pending': 'Не дзвонили',
  'blood.outcome.agreed': 'Можу прийти',
  'blood.outcome.declined': 'Не зараз',
  'blood.outcome.no_answer': 'Не відповіли',
  'blood.reason.expired': 'Прострочена (утилізація)',
  'blood.reason.damaged': 'Пошкоджений пакет',
  'blood.reason.contaminated': 'Контамінація / гемоліз',
  'blood.reason.other': 'Інша причина',
  'blood.groupUnknown': 'Група невідома',
  'blood.anyGroup': 'Будь-яка сумісна',
  'blood.expiresToday': 'спливає сьогодні',
  'blood.daysLeft': 'ще {n} день|ще {n} дні|ще {n} днів',
  'blood.daysAgo': 'прострочено {n} день тому|прострочено {n} дні тому|прострочено {n} днів тому',
  'blood.ml': 'мл',
  'blood.litre': 'л',
  'blood.volumeMl': 'Об’єм, мл',
  'blood.expiryAuto': 'Термін придатності рахується за нормативом продукту',
  'blood.locationPlaceholder': 'Холодильник 1, полиця 2',
  'blood.labelCode': 'Код етикетки',
  'blood.labelCodeHint': 'Порожньо — присвоїти BB-00001…',
  'blood.notes': 'Примітки',
  'blood.unitAdded': 'Одиницю {code} додано',
  'blood.duties': 'Обов’язки банку крові',
  'blood.dutiesHint': 'Перемішування еритромаси (двічі на добу) і щомісячна перевірка — чеклісти процесів.',
  'blood.noDuties': 'Відкритих чеклістів немає. Розклади створюються вимкненими — увімкніть їх у «Шаблони й розклади».',
  'blood.seedDuties': 'Додати чеклісти банку крові',
  'blood.dutiesSeeded': 'Чеклісти й нормативи банку крові додано',
  'blood.dutySchedules': 'Розклади',
  'blood.unit': 'Одиниця крові',
  'blood.qrAlt': 'QR-код {code}',
  'blood.printLabel': 'Друкувати етикетку',
  'blood.donor': 'Донор',
  'blood.anticoagulant': 'Консервант',
  'blood.recipient': 'Реципієнт',
  'blood.statusChanged': 'Зміна стану',
  'blood.writeOffReason': 'Причина списання',
  'blood.writeOffHint': 'Прострочені одиниці утилізують (кремація) і списують.',
  'blood.reasonPick': 'Оберіть причину',
  'blood.reserve': 'Зарезервувати',
  'blood.release': 'Зняти резерв',
  'blood.use': 'Видати пацієнту',
  'blood.writeOff': 'Списати',
  'blood.editLocation': 'Змінити місце',
  'blood.findRecipient': 'Реципієнт: кличка або власник',
  'blood.transfusionVisit': 'Візит переливання',
  'blood.confirmReserve': 'Зарезервувати для пацієнта',
  'blood.confirmUse': 'Підтвердити видачу',
  'blood.confirmWriteOff': 'Списати одиницю',
  'blood.released': 'Резерв знято',
  'blood.reservedDone': 'Одиницю зарезервовано',
  'blood.usedDone': 'Видачу записано',
  'blood.writtenOffDone': 'Одиницю списано',
  'blood.searchDonors': 'Кличка або власник',
  'blood.allDonors': 'Усі донори',
  'blood.eligibleNow': 'Допущені зараз',
  'blood.addDonor': 'Додати донора',
  'blood.addDonorHint': 'Знайдіть тварину в Enote — кличка, власник, група, дата народження й вага підтягнуться.',
  'blood.editDonor': 'Картка донора',
  'blood.criteriaHint': 'Критерії: собаки від {dog} кг, коти від {cat} кг, вік {min}–{max} років (старше {warn} — за рішенням лікаря). Значення — у «Нормативах».',
  'blood.noDonors': 'Донорів ще немає',
  'blood.noDonorsHint': 'Додайте донора з Enote: тварини з позначкою «Донор» з’являються першими.',
  'blood.eligible': 'Допущений',
  'blood.notEligible': 'Не допущений',
  'blood.years': '{n} р.',
  'blood.kg': '{n} кг',
  'blood.staffPet': 'Тварина співробітника',
  'blood.staffPetLong': 'Тварина співробітника (окремі правила списання)',
  'blood.screen': 'Скринінг',
  'blood.screenFirst': 'Спершу пройдіть скринінг',
  'blood.recordDonation': 'Донація',
  'blood.birthDate': 'Дата народження',
  'blood.phone': 'Телефон власника',
  'blood.consent': 'Згода на дзвінки',
  'blood.consentLong': 'Власник погодився, щоб йому телефонували з проханням про донацію',
  'blood.donationsCount': 'Донацій',
  'blood.screenings': 'Скринінги',
  'blood.noScreenings': 'Скринінгів ще не було',
  'blood.kindRemote': 'Дистанційний',
  'blood.kindClinical': 'Клінічний',
  'blood.passed': 'Допущено',
  'blood.failed': 'Не допущено',
  'blood.donations': 'Донації',
  'blood.noDonations': 'Донацій ще не було',
  'blood.notCompleted': 'Не відбулась',
  'blood.repeat': 'Повторна',
  'blood.first': 'Перша',
  'blood.bonus': 'бонус {sum}',
  'blood.forPatient': 'Під пацієнта: {name}',
  'blood.findPet': 'Кличка або власник у Enote',
  'blood.changePet': 'Змінити',
  'blood.enoteDonor': 'Донор в Enote',
  'blood.alreadyDonor': 'Вже в реєстрі',
  'blood.noEnoteDonors': 'В Enote немає тварин з позначкою «Донор» — почніть вводити кличку.',
  'blood.notInEnote': 'Тварини немає в Enote — заповнити вручну',
  'blood.petName': 'Кличка',
  'blood.owner': 'Власник',
  'blood.weightKg': 'Вага, кг',
  'blood.branch': 'Філіал',
  'blood.screenTitle': 'Скринінг: {name}',
  'blood.screenHint': 'Відмітьте лише перевірені пункти. Критерії звіряються з нормативами автоматично.',
  'blood.screenKind': 'Вид скринінгу',
  'blood.minWeight': 'Мінімум {n} кг',
  'blood.age': 'Вік',
  'blood.ageNorm': 'Норма {min}–{max} р., старше {warn} — попередження',
  'blood.ageUnknown': 'невідомий — вкажіть дату народження в картці',
  'blood.typedGroup': 'Група крові (типування)',
  'blood.crit.vaccinated': 'Вакцинація актуальна',
  'blood.crit.parasite_treated': 'Обробка від паразитів',
  'blood.crit.no_symptoms': 'Немає симптомів хвороби (опитування власника)',
  'blood.crit.no_therapy': 'Не на терапії / імуносупресорах',
  'blood.crit.no_prior_transfusion': 'Раніше не отримував кров',
  'blood.crit.cbc_ok': 'ЗАК у нормі',
  'blood.crit.biochem_ok': 'Біохімія в нормі',
  'blood.crit.infection_test_negative': 'Експрес-тест на трансмісивні інфекції негативний',
  'blood.crit.heart_ok': 'УЗД серця без змін',
  'blood.previewOk': 'Критерії виконано — донора буде допущено',
  'blood.previewFail': 'Не допущено: не виконано критеріїв — {n}',
  'blood.previewWarn': 'Є попередження: рішення за лікарем.',
  'blood.saveScreening': 'Зберегти скринінг',
  'blood.screenPassed': 'Скринінг пройдено',
  'blood.screenFailed': 'Скринінг збережено: не допущено',
  'blood.donationTitle': 'Донація: {name}',
  'blood.donationHint': 'Одиниці отримають коди етикеток і термін придатності за нормативом продукту.',
  'blood.completed': 'Донація відбулась',
  'blood.notCompletedLong': 'Донація не відбулась (списання 0, бонус не нараховується)',
  'blood.collectedVolume': 'Відібрано, мл',
  'blood.donationVisit': 'Візит «Прийом для донації»',
  'blood.donationVisitHint': 'Потрібен для пакета списання: звірка чека донації',
  'blood.noVisit': 'Не прив’язано',
  'blood.forPatientLabel': 'Донор прийшов «під пацієнта» (необов’язково)',
  'blood.unitsMade': 'Отримані одиниці',
  'blood.addUnitRow': 'Ще одиниця',
  'blood.unitsHint': 'Рядки без об’єму не зберігаються. Терміново у ВРІТ — цільна кров.',
  'blood.donationSaved': 'Донацію збережено, одиниць: {n}',
  'blood.noBotCalls':
    'Bridge не пише власникам донорів: рішення власника клініки ще не прийнято. Запит формує список для дзвінків і шаблон повідомлення — телефонуйте або пишіть вручну.',
  'blood.botReserved': 'Налаштування бот-розсилки увімкнено, але поки не діє: Bridge не пише власникам донорів. Телефонуйте за списком.',
  'blood.newRequest': 'Запит на донора',
  'blood.newRequestHint': 'Сумісні донори, допущені зараз і згодні на дзвінки, потраплять у список для обдзвону.',
  'blood.recipientGroup': 'Група реципієнта',
  'blood.createTask': 'Створити завдання',
  'blood.createTaskLong': 'Створити завдання «Обдзвонити донорів» зі списком і шаблоном',
  'blood.buildCallList': 'Сформувати список',
  'blood.requestCreated': 'Запит створено, донорів у списку: {n}',
  'blood.noRequests': 'Запитів ще немає',
  'blood.noRequestsHint': 'Коли пацієнту потрібна кров, створіть запит — Bridge підбере сумісних донорів для дзвінків.',
  'blood.callsSummary': '{agreed} згодні · {pending} ще не дзвонили · {total} усього',
  'blood.requestOpen': 'Відкритий',
  'blood.requestClosed': 'Закритий',
  'blood.request': 'Запит',
  'blood.compatibleInStock': 'Сумісних одиниць у наявності: {n}',
  'blood.openTask': 'Завдання',
  'blood.closeRequest': 'Закрити запит',
  'blood.requestClosedDone': 'Запит закрито',
  'blood.callListHint': 'Зателефонуйте власникам і відмітьте відповідь. Шаблон можна скопіювати для месенджера.',
  'blood.noCompatibleDonors': 'Сумісних допущених донорів зі згодою немає',
  'blood.noCompatibleDonorsHint': 'Потрібен пост у соцмережах з фото реципієнта (регламент банку крові).',
  'blood.messageTemplate': 'Шаблон повідомлення',
  'blood.callNote': 'Коментар до дзвінка',
  'blood.prevMonth': 'Попередній місяць',
  'blood.nextMonth': 'Наступний місяць',
  'blood.print': 'Друк',
  'blood.packHint':
    'Пакет для фінансиста: донації місяця для одного ордера «Коригування боргів» в Enote (бонус з другої донації) і одиниці, списані за місяць. Позиції чека, не схожі на послуги донації, позначені як сторонні.',
  'blood.totDonations': 'Донацій',
  'blood.totRepeat': 'повторних: {n}',
  'blood.totWriteOff': 'Списати в Enote',
  'blood.totBonus': 'бонуси на аванс: {sum}',
  'blood.totForeign': 'Сторонніх позицій',
  'blood.totUnits': 'Одиниць списано',
  'blood.packDonations': 'Донації',
  'blood.enoteComment': 'Коментар в Enote',
  'blood.packNoDonations': 'Донацій за цей місяць немає',
  'blood.packNoMoney': 'Суми бачать лише ролі з доступом до оплат.',
  'blood.packUnits': 'Списані одиниці',
  'blood.packNoUnits': 'За місяць нічого не списано',
  'blood.packExpiredOpen': 'Прострочених одиниць ще не списано: {n}. Утилізуйте й спишіть їх на вкладці «Запаси».',
  'blood.noFlags': 'Зауважень немає',
}

export const bloodbankEn: Partial<Record<keyof typeof bloodbankUk, string>> = {
  'nav.bloodBank': 'Blood bank',
  'process.area.blood_bank': 'Blood bank',
  'perm.bloodbank.read': 'Blood bank: view and donor calls',
  'perm.bloodbank.manage': 'Blood bank: donors, donations, units',
  'blood.subtitle': 'Donors, blood units with expiry, donor requests and the monthly write-off',
  'blood.tabStock': 'Stock',
  'blood.tabDonors': 'Donors',
  'blood.tabRequests': 'Requests',
  'blood.tabPack': 'Monthly write-off',
  'blood.statInStock': 'Units in stock',
  'blood.statExpiring': 'Expiring (≤ {n} d)',
  'blood.statExpired': 'Expired — dispose',
  'blood.statDonors': 'Donors',
  'blood.statDonorsSub': 'eligible now / active',
  'blood.statRequests': 'Open requests',
  'blood.normsToConfirm': 'Blood bank norms waiting for the owner: {n}.',
  'blood.openNorms': 'Open norms',
  'blood.stockByGroup': 'Stock by group',
  'blood.noStock': 'No blood units in stock',
  'blood.noStockHint': 'Record a donation on a donor card or add a unit from the paper register.',
  'blood.searchUnits': 'Label code, donor or recipient',
  'blood.filterInStock': 'In stock and expired',
  'blood.filterSoon': 'Expiring soon',
  'blood.filterHistory': 'Used and written off',
  'blood.allSpecies': 'All species',
  'blood.allProducts': 'All products',
  'blood.addUnit': 'Add unit',
  'blood.addUnitHint': 'For units from the paper register. Record new donations on the donor card.',
  'blood.noUnits': 'No units for this filter',
  'blood.noUnitsHint': 'Change the filter or record a donation on a donor card.',
  'blood.col.code': 'Code',
  'blood.col.product': 'Product',
  'blood.col.group': 'Species and group',
  'blood.col.groups': 'Groups (available + reserved)',
  'blood.col.volume': 'Volume',
  'blood.col.collected': 'Collected',
  'blood.col.expires': 'Expires',
  'blood.col.nextExpiry': 'Next expiry',
  'blood.col.location': 'Storage',
  'blood.col.status': 'Status',
  'blood.col.species': 'Species',
  'blood.col.donor': 'Donor',
  'blood.col.ageWeight': 'Age · weight',
  'blood.col.lastDonation': 'Last donation',
  'blood.col.nextDonation': 'Next possible',
  'blood.col.request': 'Request',
  'blood.col.calls': 'Calls',
  'blood.col.inStock': 'Compatible in stock',
  'blood.col.created': 'Created',
  'blood.col.date': 'Date',
  'blood.col.donationKind': 'Donation',
  'blood.col.visit': 'Enote visit',
  'blood.col.forPatient': 'For a patient',
  'blood.col.visitTotal': 'Visit total',
  'blood.col.writeOff': 'Write off',
  'blood.col.bonus': 'Bonus',
  'blood.col.foreign': 'Foreign items',
  'blood.col.warnings': 'Check',
  'blood.col.writtenOffAt': 'Written off',
  'blood.col.by': 'By',
  'blood.product.rbc': 'Red cells',
  'blood.product.plasma': 'Plasma',
  'blood.product.whole': 'Whole blood',
  'blood.species.dog': 'Dog',
  'blood.species.cat': 'Cat',
  'blood.unitStatus.available': 'Available',
  'blood.unitStatus.reserved': 'Reserved',
  'blood.unitStatus.used': 'Used',
  'blood.unitStatus.expired': 'Expired',
  'blood.unitStatus.written_off': 'Written off',
  'blood.donorStatus.candidate': 'Candidate',
  'blood.donorStatus.active': 'Active',
  'blood.donorStatus.paused': 'Paused',
  'blood.donorStatus.retired': 'Retired',
  'blood.outcome.pending': 'Not called',
  'blood.outcome.agreed': 'Can come',
  'blood.outcome.declined': 'Not now',
  'blood.outcome.no_answer': 'No answer',
  'blood.reason.expired': 'Expired (disposal)',
  'blood.reason.damaged': 'Damaged bag',
  'blood.reason.contaminated': 'Contamination / haemolysis',
  'blood.reason.other': 'Other reason',
  'blood.groupUnknown': 'Group unknown',
  'blood.anyGroup': 'Any compatible',
  'blood.expiresToday': 'expires today',
  'blood.daysLeft': '{n} day left|{n} days left|{n} days left',
  'blood.daysAgo': 'expired {n} day ago|expired {n} days ago|expired {n} days ago',
  'blood.ml': 'ml',
  'blood.litre': 'l',
  'blood.volumeMl': 'Volume, ml',
  'blood.expiryAuto': 'Expiry follows the product norm',
  'blood.locationPlaceholder': 'Fridge 1, shelf 2',
  'blood.labelCode': 'Label code',
  'blood.labelCodeHint': 'Empty — assign BB-00001…',
  'blood.notes': 'Notes',
  'blood.unitAdded': 'Unit {code} added',
  'blood.duties': 'Blood bank duties',
  'blood.dutiesHint': 'Red-cell mixing (twice a day) and the monthly check are process checklists.',
  'blood.noDuties': 'No open checklists. Schedules are created paused — turn them on in «Templates & schedules».',
  'blood.seedDuties': 'Add blood bank checklists',
  'blood.dutiesSeeded': 'Blood bank checklists and norms added',
  'blood.dutySchedules': 'Schedules',
  'blood.unit': 'Blood unit',
  'blood.qrAlt': 'QR code {code}',
  'blood.printLabel': 'Print label',
  'blood.donor': 'Donor',
  'blood.anticoagulant': 'Anticoagulant',
  'blood.recipient': 'Recipient',
  'blood.statusChanged': 'Status changed',
  'blood.writeOffReason': 'Write-off reason',
  'blood.writeOffHint': 'Expired units are disposed of (cremation) and written off.',
  'blood.reasonPick': 'Choose a reason',
  'blood.reserve': 'Reserve',
  'blood.release': 'Release',
  'blood.use': 'Give to a patient',
  'blood.writeOff': 'Write off',
  'blood.editLocation': 'Change storage',
  'blood.findRecipient': 'Recipient: pet or owner name',
  'blood.transfusionVisit': 'Transfusion visit',
  'blood.confirmReserve': 'Reserve for the patient',
  'blood.confirmUse': 'Confirm',
  'blood.confirmWriteOff': 'Write the unit off',
  'blood.released': 'Reservation released',
  'blood.reservedDone': 'Unit reserved',
  'blood.usedDone': 'Transfusion recorded',
  'blood.writtenOffDone': 'Unit written off',
  'blood.searchDonors': 'Pet or owner name',
  'blood.allDonors': 'All donors',
  'blood.eligibleNow': 'Eligible now',
  'blood.addDonor': 'Add donor',
  'blood.addDonorHint': 'Find the pet in Enote — name, owner, group, birth date and weight are copied.',
  'blood.editDonor': 'Donor card',
  'blood.criteriaHint': 'Criteria: dogs from {dog} kg, cats from {cat} kg, age {min}–{max} years (above {warn} — doctor decides). Values live in «Norms».',
  'blood.noDonors': 'No donors yet',
  'blood.noDonorsHint': 'Add a donor from Enote: pets marked «Донор» are listed first.',
  'blood.eligible': 'Eligible',
  'blood.notEligible': 'Not eligible',
  'blood.years': '{n} y',
  'blood.kg': '{n} kg',
  'blood.staffPet': 'Staff pet',
  'blood.staffPetLong': 'Pet of an employee (separate write-off rules)',
  'blood.screen': 'Screening',
  'blood.screenFirst': 'Screen the donor first',
  'blood.recordDonation': 'Donation',
  'blood.birthDate': 'Birth date',
  'blood.phone': 'Owner’s phone',
  'blood.consent': 'Consent to calls',
  'blood.consentLong': 'The owner agreed to be called with donation requests',
  'blood.donationsCount': 'Donations',
  'blood.screenings': 'Screenings',
  'blood.noScreenings': 'No screenings yet',
  'blood.kindRemote': 'Remote',
  'blood.kindClinical': 'Clinical',
  'blood.passed': 'Passed',
  'blood.failed': 'Not passed',
  'blood.donations': 'Donations',
  'blood.noDonations': 'No donations yet',
  'blood.notCompleted': 'Did not happen',
  'blood.repeat': 'Repeat',
  'blood.first': 'First',
  'blood.bonus': 'bonus {sum}',
  'blood.forPatient': 'For patient: {name}',
  'blood.findPet': 'Pet or owner name in Enote',
  'blood.changePet': 'Change',
  'blood.enoteDonor': 'Donor in Enote',
  'blood.alreadyDonor': 'Registered',
  'blood.noEnoteDonors': 'No pets marked «Донор» in Enote — start typing a name.',
  'blood.notInEnote': 'Not in Enote — fill in by hand',
  'blood.petName': 'Pet name',
  'blood.owner': 'Owner',
  'blood.weightKg': 'Weight, kg',
  'blood.branch': 'Branch',
  'blood.screenTitle': 'Screening: {name}',
  'blood.screenHint': 'Tick only what was checked. Criteria are compared with the norms automatically.',
  'blood.screenKind': 'Screening kind',
  'blood.minWeight': 'Minimum {n} kg',
  'blood.age': 'Age',
  'blood.ageNorm': 'Norm {min}–{max} y, above {warn} — warning',
  'blood.ageUnknown': 'unknown — set the birth date on the card',
  'blood.typedGroup': 'Blood group (typing)',
  'blood.crit.vaccinated': 'Vaccinations up to date',
  'blood.crit.parasite_treated': 'Parasite treatment',
  'blood.crit.no_symptoms': 'No symptoms of illness (owner survey)',
  'blood.crit.no_therapy': 'Not on therapy / immunosuppressants',
  'blood.crit.no_prior_transfusion': 'Never received blood',
  'blood.crit.cbc_ok': 'Blood count within norm',
  'blood.crit.biochem_ok': 'Biochemistry within norm',
  'blood.crit.infection_test_negative': 'Infection express test negative',
  'blood.crit.heart_ok': 'Heart ultrasound without findings',
  'blood.previewOk': 'Criteria met — the donor will be eligible',
  'blood.previewFail': 'Not eligible: criteria not met — {n}',
  'blood.previewWarn': 'There are warnings: the doctor decides.',
  'blood.saveScreening': 'Save screening',
  'blood.screenPassed': 'Screening passed',
  'blood.screenFailed': 'Screening saved: not eligible',
  'blood.donationTitle': 'Donation: {name}',
  'blood.donationHint': 'Units get label codes and expiry from the product norms.',
  'blood.completed': 'The donation happened',
  'blood.notCompletedLong': 'The donation did not happen (write-off 0, no bonus)',
  'blood.collectedVolume': 'Collected, ml',
  'blood.donationVisit': 'Visit «Прийом для донації»',
  'blood.donationVisitHint': 'Needed by the write-off pack to check the donation receipt',
  'blood.noVisit': 'Not linked',
  'blood.forPatientLabel': 'The donor came for a patient (optional)',
  'blood.unitsMade': 'Units made',
  'blood.addUnitRow': 'Another unit',
  'blood.unitsHint': 'Rows without a volume are skipped. Urgent to the ward — whole blood.',
  'blood.donationSaved': 'Donation saved, units: {n}',
  'blood.noBotCalls': 'Bridge does not message donor owners: the owner has not decided yet. A request builds a call list and a message template — call or write by hand.',
  'blood.botReserved': 'The bot setting is on but has no effect yet: Bridge does not message donor owners. Call from the list.',
  'blood.newRequest': 'Donor request',
  'blood.newRequestHint': 'Compatible donors that are eligible now and agreed to calls form the call list.',
  'blood.recipientGroup': 'Recipient’s group',
  'blood.createTask': 'Create a task',
  'blood.createTaskLong': 'Create a task «Call donors» with the list and the template',
  'blood.buildCallList': 'Build the list',
  'blood.requestCreated': 'Request created, donors on the list: {n}',
  'blood.noRequests': 'No requests yet',
  'blood.noRequestsHint': 'When a patient needs blood, create a request — Bridge picks compatible donors to call.',
  'blood.callsSummary': '{agreed} agreed · {pending} not called · {total} total',
  'blood.requestOpen': 'Open',
  'blood.requestClosed': 'Closed',
  'blood.request': 'Request',
  'blood.compatibleInStock': 'Compatible units in stock: {n}',
  'blood.openTask': 'Task',
  'blood.closeRequest': 'Close request',
  'blood.requestClosedDone': 'Request closed',
  'blood.callListHint': 'Call the owners and record the answer. Copy the template for a messenger.',
  'blood.noCompatibleDonors': 'No compatible eligible donors with consent',
  'blood.noCompatibleDonorsHint': 'Post in social media with the recipient’s photo (blood bank regulation).',
  'blood.messageTemplate': 'Message template',
  'blood.callNote': 'Call note',
  'blood.prevMonth': 'Previous month',
  'blood.nextMonth': 'Next month',
  'blood.print': 'Print',
  'blood.packHint':
    'Pack for the finance role: the month’s donations for one Enote debt correction (bonus from the second donation) and the units written off in the month. Receipt lines that do not look like donation services are flagged as foreign.',
  'blood.totDonations': 'Donations',
  'blood.totRepeat': 'repeat: {n}',
  'blood.totWriteOff': 'Write off in Enote',
  'blood.totBonus': 'bonuses to advance: {sum}',
  'blood.totForeign': 'Foreign items',
  'blood.totUnits': 'Units written off',
  'blood.packDonations': 'Donations',
  'blood.enoteComment': 'Enote comment',
  'blood.packNoDonations': 'No donations this month',
  'blood.packNoMoney': 'Amounts are visible only to roles with access to payments.',
  'blood.packUnits': 'Units written off',
  'blood.packNoUnits': 'Nothing written off this month',
  'blood.packExpiredOpen': 'Expired units not written off yet: {n}. Dispose of them and write them off on the «Stock» tab.',
  'blood.noFlags': 'No findings',
}
